import { mapState } from 'vuex'

const mixin = {
  computed: {
    ...mapState({
      currentLang: (state: any) => state.i18n.lang
    })
  },
  methods: {
    setLang(lang: any) {
      (this as any).$store.dispatch('i18n/changeLang', lang)
    },
    totalFanyi(number: any) {
      const total = (this as any).$t('Total…items') as string
      return total.replace('{0}', number)
    }
  }
}

export { mixin }
